import { Form, Input, Row, Col, Switch } from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import WangeditorV5ForAntD from '../../../utilsTsx/components/wangeditor/WangeditorV5ForAntD';
import systematic from '../../../config/systematic';
import FilesInput from '../../../utilsTsx/components/files/FilesInput';

const EditComponent = (props: any) => {
    const { editMode } = props;
    const apiId = 'app';
    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);
    const [id, setId] = useState<string>();

    useEffect(() => {
        ref?.current?.getRow?.then(async (res: any) => {
            if (res?.success === true) {
                const { id } = res.data;
                setId(id);
            }
        })
    }, []);

    const extendProps: WebEditUniversalProps = {
        ...props,
        apiId,
        displayOptions: {
            width: 1380
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={8}>
                        <Row gutter={[8, 0]}>
                            <Col span={24}>
                                <Form.Item
                                    label="ID"
                                    name="id">
                                    <Input disabled={editMode === 'NEW' ? false : true} />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="名称"
                                    name="name"
                                    rules={[{ required: true, message: '名称!' }]}>
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="封面图"
                                    name="coverImage"
                                    tooltip='应用封面图地址'>
                                    <FilesInput
                                        defaultService={systematic.bmService}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="状态"
                                    name="isUse"
                                    valuePropName="checked"
                                    initialValue={true}>
                                    < Switch checked={true}
                                        checkedChildren="启用"
                                        unCheckedChildren="关闭" />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="备注"
                                    name="remarks">
                                    < Input.TextArea autoSize={{ minRows: 2, maxRows: 10 }} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={16}>
                        <Form.Item
                            label=""
                            name="description">
                            <WangeditorV5ForAntD
                                key={id}
                                id={`${apiId}${id}`}
                                title='描述'
                                displayMode="editor"
                                defaultService={systematic.bmService}
                                style={{ height: 500 }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            )
        }
    };
    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default EditComponent;